import {CommentsCategory, CommentStatus, type CommentDto} from '@domain/comments'
import {ApiClient} from '@hconnect/apiclient'
import {parseIsoDateStringToDate} from '@hconnect/common/dates/ISO8601Helpers'
import {orderBy} from 'lodash'

import {PomComment, RequestFunc} from '../../types'

import {loggingDecorator} from './decorators'

const convertCommentFromDto = (commentDto: CommentDto): PomComment => {
  const isEdited = commentDto.status === CommentStatus.Edited

  return {
    id: commentDto.commentId,
    createdOn: parseIsoDateStringToDate(commentDto.createdOn),
    createdBy: commentDto.createdBy,
    referenceId: commentDto.commentsCategoryInstanceId,
    status: commentDto.status,
    value: commentDto.value,
    ...(isEdited && {
      updatedBy: commentDto.updatedBy,
      updatedOn: parseIsoDateStringToDate(commentDto.updatedOn)
    })
  }
}

const COMMENTS_CATEGORY = CommentsCategory.POMQuestions

const addCommentImpl: RequestFunc<
  {
    plantId: string
    questionId: string
    comment: string
  },
  PomComment
> = async ({plantId, questionId, comment}) => {
  const {data} = await ApiClient.axiosInstance.post<CommentDto>(
    `comments/${plantId}/${COMMENTS_CATEGORY}/${questionId}`,
    {
      value: comment
    }
  )
  return convertCommentFromDto(data)
}
export const addComment = loggingDecorator(addCommentImpl)

const getCommentsImpl: RequestFunc<
  {
    plantId: string
    questionId: string
  },
  PomComment[]
> = async ({plantId, questionId}) => {
  const {data} = await ApiClient.axiosInstance.get<CommentDto[]>(
    `/comments/${plantId}/${COMMENTS_CATEGORY}?commentCategoryInstanceIds=${questionId}`
  )
  return orderBy(data.map(convertCommentFromDto), ['createdOn'], ['desc'])
}

export const getComments = loggingDecorator(getCommentsImpl)

const updateCommentImpl: RequestFunc<
  {
    plantId: string
    comment: PomComment
  },
  void
> = async ({plantId, comment}) => {
  const {id, referenceId, value} = comment
  await ApiClient.axiosInstance.put(
    `comments/${plantId}/${COMMENTS_CATEGORY}/${referenceId}/${id}`,
    {
      value
    }
  )
}

export const updateComment = loggingDecorator(updateCommentImpl)

const deleteCommentImpl: RequestFunc<
  {
    plantId: string
    comment: PomComment
  },
  void
> = async ({plantId, comment}) => {
  const {id, referenceId} = comment
  await ApiClient.axiosInstance.delete(
    `comments/${plantId}/${COMMENTS_CATEGORY}/${referenceId}/${id}`
  )
}

export const deleteComment = loggingDecorator(deleteCommentImpl)
